import React, { useState,useEffect, useContext } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { db } from '../../Firebase/firebase'
import SinglePostComments from '../SinglePostComments/SinglePostComments'
import firebase from 'firebase'
import './SinglePostMain.css'
import { AuthContext } from '../../Context/AuthContext/AuthContext'
import { ThemeContext } from '../../Context/ThemeContext/ThemeContext'
import LoadingIcon from '../../LoadingIcon/LoadingIcon'

const SinglePostMain = () => {
  const  history  = useHistory()
  const { currentUser }  = useContext(AuthContext)
  const { isLight } = useContext(ThemeContext)
  const { postID } = useParams()

  const [loading,isLoading] = useState(true)
  
  const [title, setTitle] = useState('')  
  const [para, setPara] = useState('')
  const [userName, setUserName] = useState('')
  const [platform, setPlatform] = useState('')
  const [imgURL, setImgURL] = useState('')

  const [editing, isEditing] = useState(false)
  const [paraText, setParaText] = useState('')

  

  //* UPDATING POST
  const updatePost = () => {

    db.collection('posts').doc(postID).update(
      {
        postText: paraText
      }
    )
      .then(() => isEditing(false))
      .catch(err => alert(err.message))
  }

  //* DELETE POST
  const deletePost = () => {
    db.collection('posts').doc(postID).delete()
      .then(() => {
        history.push('/')
      })
      .catch(err => alert(err.message))
  }

  const [comment, setComment] = useState('')
  //*HANDLES POSTING COMMENT
  const handleSubmit = e => {
    e.preventDefault()

    if(currentUser){

      db.collection('posts').doc(postID).collection('comments').add({
        userName: currentUser.displayName,
        comment,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      }).then(() => {
        setComment('')
      })
    } else {
      alert("You need to login to create an account")
    }
  }

  useEffect(() => {
    isLoading(true)
    if(postID){
      db.collection('posts').doc(postID).onSnapshot(snapshot => {
        
        const { postText, postTitle,userName, platform,imgURL } = snapshot.data()
        
        setPara(postText)
        setTitle(postTitle)
        setUserName(userName)
        setPlatform(platform)
        setParaText(postText)
        setImgURL(imgURL)
        isLoading(false)
      })
    }
  }, [postID])

  return (
    <section className={`single-post-main ${isLight ? "" : "dark"}`}>
      {
        loading ? (
          <div className="loading-icon-container">

            <LoadingIcon />
          </div>
        ) : (
          <div className="single-post-main__container">
            <div className="single-post-main__user-details">
              <div className="single-post-main__platform">
                <h1>TP/{platform}</h1>
              </div>
              <div className="single-post-main__user">
                <h1>By TPu/{userName}</h1>
              </div>
            </div>

            <div className="single-post-main__post-details"> 
                <div className="single-post-main__title">
                  <h1>{title}</h1>
                </div>
                <img src={imgURL} alt="" className="single-post-main__img"/>
                <div className="single-post-main__para">
                  {
                    editing ? (  //*If editing is true it will show a input box and three button
                      <div className="comment__form">
                        <textarea type="text" className="single-post-main__input" required value={paraText} onChange={e => setParaText(e.target.value)}/>
                        <div className="comment__editing__col">
                          <button className="comment__edit-btn update" onClick={updatePost}>Change</button>
                          <button className="comment__edit-btn cancel" onClick={() => isEditing(false)}>Cancel</button>
                          <button className="comment__edit-btn delete" onClick={deletePost}>Delete</button>
                        </div>
                      </div>
                    ) : (
                        <>
                          <p>{para}</p>
                        </>
                      )
                  }
              </div>
            </div>
              
            {currentUser ? (
              currentUser.displayName === userName ? ( //* this check whether the user can edit the post or no
                editing ? "" : (                        //* this check whethere to show the edit button or not based on if the user is editing  
                  <div className="single-post-main__edit__btn">
                    <button className="single-post-main__edit" onClick={() => isEditing(!editing)}>Edit</button>
                  </div>
                )
              ) : ""
            ) : ""}

            <form action="" className="single-post-main__form" onSubmit={handleSubmit}>
              <textarea placeholder="Say something nice :)" className="single-post-main__textarea" required value={comment} onChange={e => setComment(e.target.value)} />
              <button className="single-post-main__btn" type="submit">Post</button>
            </form>

            <SinglePostComments />
          </div>
        )
      }
      
    </section>
  )
}

export default SinglePostMain
